module.exports = __webpack_public_path__ + "static/media/dotted.c760b740.svg";